import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { ListItem, ListItemIcon } from 'components/ui';
import { DragIndicatorIcon } from 'components/uiIcons';

const Item = ({ id, index, arrayHelpers, moveCard, children }) => {
  const ref = useRef(null);
  const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveCard(dragIndex, hoverIndex, arrayHelpers);

      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <ListItem
      className={isDragging ? 'dragging' : ''}
      ref={ref}
      data-handler-id={handlerId}
      disableGutters
      key={index}
    >
      <ListItemIcon>
        <DragIndicatorIcon style={{ cursor: 'pointer' }} />
      </ListItemIcon>
      {children}
    </ListItem>
  );
};

export default Item;
